import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { GbLoadingSpinnerComponent } from './gb-loading-spinner.component'

@Injectable({
  providedIn: 'root',
})
export class GbLoadingSpinnerDialogService {
  dialogConfig: MatDialogConfig = {
    disableClose: true,
    panelClass: 'loading-dialog',
    minWidth: '165px',
    maxWidth: '300px',
    minHeight: '150px',
    hasBackdrop: false,
  }

  constructor(private dialog: MatDialog) {}

  showLoadingSpinnerDialog(id: string, label = ''): void {
    if (!this.isDialogOpen(id)) {
      const dialogRef = this.dialog.open(GbLoadingSpinnerComponent, {
        ...this.dialogConfig,
        id,
      })
      dialogRef.componentInstance.id = id
      dialogRef.componentInstance.label = label
    }
  }

  hideLoadingSpinnerDialog(id: string): void {
    if (this.isDialogOpen(id)) {
      this.dialog.getDialogById(id)?.close()
    }
  }

  private isDialogOpen(id: string): boolean {
    return this.dialog.getDialogById(id) !== undefined
  }
}
